import { Avatar, Box, Chip, Divider, Stack, Typography } from "@mui/material";
import React from "react";
const UserAndActionDetails = ({
  user,
  rating,
  finalScore,
  parameters,
  finalDetail,
  moduleAverages,
  managerView,
}) => {
  return (
    <Box>
      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          borderRadius: 2,
          p: 2,
          mb: 2,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Avatar
            alt={user?.name || "User"}
            src={`https://workspace.teaminterval.net/assets/employee/photo/passport_size/${user?.photo}.jpg`}
            sx={{ width: 60, height: 60 }}
          />
        </Box>

        <Typography variant="h6" fontWeight="bold">
          {user.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {user.departmentName}
        </Typography>
      </Box>
      <Divider />
      <Stack p={1} spacing={1}>
        {[
          { label: "Self Rating", value: finalDetail?.rating?.user },
          ...(managerView
            ? [
                {
                  label: "Reviewer Rating",
                  value: finalDetail?.rating?.manager,
                },
              ]
            : []),
          {
            label: "Self Final Score ",
            value: finalDetail?.finalScore?.user || 0,
          },
          ...(managerView
            ? [
                {
                  label: "Reviewer Final Score",
                  value: finalDetail?.finalScore?.manager || 0,
                },
              ]
            : []),
        ].map((item) => (
          <Box
            key={item.label}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#f9f9f9",
              borderRadius: 1,
              px: 2,
              py: 1,
              boxShadow: 0,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: "text.secondary",
                flexShrink: 0,
              }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 400,
                color: "text.primary",
                textAlign: "right",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "0.75rem",
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Stack>

      <Divider />

      <Stack
        spacing={1}
        p={1}
        sx={{ 
          maxHeight: 300,
           overflowY: "auto", overflowX: "hidden" 
          }}
      >
        {Array.isArray(parameters) &&
          parameters.map((p) => (
            <Chip
              key={p}
              sx={{
                backgroundColor: "#f5f5f5",
                "& .MuiChip-label": {
                  fontSize: "0.65rem",
                  fontWeight: 500,
                },
              }}
              label={p.replace(/_/g, " ").toUpperCase()}
              variant="outlined"
              size="small"
            />
          ))}
      </Stack>
    </Box>
  );
};

export default UserAndActionDetails;
